<template>
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import { userData } from '@/store/helpers'
import UserServices from '@/services/UserServices'

export default {
  name: 'App',

  components: {},

  data: () => ({
    //
  }),
  mounted() {
    this.$el.addEventListener('click',this.onClick);
    window.inlineManualOptions = { language: 'es'};
    var player_url = `https://cdn.inlinemanual.com/embed/player.${process.env.VUE_APP_INLINE_APIKEY}.js`;
    !function(){var e=document.createElement("script");var t=document.getElementsByTagName("script")[0];e.async=1;e.src=player_url;e.charset="UTF-8";t.parentNode.insertBefore(e,t)}();
    !function(){var idz = document.createElement('script');idz.type = 'text/javascript';idz.async = true;idz.src = document.location.protocol + '//halc.iadvize.com/iadvize.js?sid=5665';var s = document.getElementsByTagName('script')[0];s.parentNode.insertBefore(idz, s);}();
    !function(){
      let doc = document.createElement('script')
      let t = document.getElementsByTagName("script")[0];
      doc.textContent = "window.iAdvizeInterface = window.iAdvizeInterface || [];" +
        "iAdvizeInterface.config = {'sid': 5665};"
      t.parentNode.insertBefore(doc,t);
    }();
    !function(){
      let doc = document.createElement('script')
      let t = document.getElementsByTagName("script")[0];
      doc.setAttribute('type', 'module')
      doc.setAttribute('src', '//halc.iadvize.com/iadvize.js')
      t.parentNode.insertBefore(doc,t);
    }();  
  },
  computed: {
    ...userData
  },
  watch: {
    userId: function(value){
      if(!value) {
        return;
      }

      window.inlineManualTracking = {
        uid: process.env.VUE_APP_INLINE_TRACKING_EMAIL,
        email: process.env.VUE_APP_INLINE_TRACKING_EMAIL,
        username: process.env.VUE_APP_INLINE_TRACKING_EMAIL,
        name: process.env.VUE_APP_INLINE_TRACKING_EMAIL,
        created: 1360610467,
        updated: 1433168312,
        roles: ["user"],
        group: process.env.VUE_APP_INLINE_TRACKING_GROUP,
        plan: this.accountData.tipoSuscripcion
      }

      const service = new UserServices()
      service.getAccount(value).then(({ data }) => {
        let owner = {
          email: data.data.correo_electronico,
          nombres: data.data.nombres,
          paterno: data.data.paterno,
          materno: data.data.materno
        }
        window.idzCustomData = {
          cust_asesorcontpaqi: false,
          cust_certificaciones: 0,
          cust_cid: 0,
          cust_email: owner.email,
          cust_excomercial: false,
          cust_excontable: false,
          cust_mesaservicio: false,
          cust_nivel: 'value',
          cust_tipo: 'value',
          extid: value,
          logged_in: true,
          page_type: 'Singlepage',
          distribuidor_de_servicio: 'value',
          distribuidor_de_venta: 'value',
          cust_nombre: `${owner.nombres} ${owner.paterno} ${owner.materno}`,
          cust_url:'firma.contpaqinube.com',
          cust_idsistema: 9087,
          rfc: 'value',
          razon_social: 'value',
          telefono: 0,
          ciudad: 'value',
          estado: 'value',
          pais: 'value'
        }
      })
    }
  },
  methods:{
    onClick: function(){
      document.querySelectorAll('input[required]').forEach(e => {e ? e.parentElement.classList.add('required-input') : null})
    }
  },
  destroyed(){
    this.$el.addEventListener('click',this.onClick);
  }
}
</script>

<style>
.inmplayer-trigger {
  visibility: hidden;
}

.required-input > label::after {
  content: "*";
}
</style>